// Which languages a voice is for, from its name: "Goku (Latino)" is for
// Spanish speakers. Client-safe (no searchEarners.json), so voice cards can
// use it; utils/voiceIndexing.ts builds the indexable languages on top.
import type { Locale } from "@jammable/ui-core/src/i18n";

// Matched against the voice's name and slug. Japanese and Korean mostly hit
// voices labelled with the language ("Goku (Japanese)", "(KR)").
// Labels, not bare words: "German Garmendia" (a Chilean YouTuber) and
// "French Montana" are not German or French voices, but "(German)",
// "German dub", "Deutsch", "(French Icon)" and "VF" are.
export const LOCALE_AUDIENCE: Record<Exclude<Locale, "en">, RegExp> = {
  es: /latino|latam|espa(n|ñ)ol|castellano|doblaje|mexic|argentin/i,
  pt: /brasil|brazil|pt-?br|dublad|dublagem|portugu/i,
  fr: /fran(c|ç)ais|\(french|french (dub|version|voice)|\bvf\b|qu(e|é)b(e|é)c|doublage/i,
  de: /deutsch|\(german|german (dub|version|voice)|synchron/i,
  ja: /japanese|日本|\(jp\)|\bjpn\b|seiyuu|声優/i,
  ko: /korean|한국|\(kr\)|\bkor\b/i,
  id: /indonesia|bahasa/i,
  tr: /t(u|ü)rk(c|ç)e|turkish|\(t(u|ü)rk/i,
};

export function voiceSpeaksTo(
  voice: { artistname?: string; urlParam?: string },
  locale: Locale,
): boolean {
  if (locale === "en") return true;
  return LOCALE_AUDIENCE[locale].test(
    `${voice.artistname || ""} ${voice.urlParam || ""}`,
  );
}
